import React from 'react';
import Icon from '../Icon/Icon';
var css = {
  "cardCarousel": "rui-X3Oj1",
  "imageContainer": "rui-5HOI8",
  "tags": "rui-Z1m3v",
  "image": "rui-6SWMg",
  "cardContent": "rui-2UYTN",
  "title": "rui-oM47u",
  "subtitle": "rui-ZDFIk",
  "body": "rui-r3oXR"
};
export var NewCardCarouselSmall = function NewCardCarouselSmall(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    installment = _ref.installment,
    body = _ref.body,
    image = _ref.image,
    tags = _ref.tags,
    icon = _ref.icon,
    iconSize = _ref.iconSize,
    onIconClick = _ref.onIconClick,
    iconColor = _ref.iconColor;
  return /*#__PURE__*/React.createElement("div", {
    className: css.cardCarousel
  }, image && /*#__PURE__*/React.createElement("div", {
    className: css.imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: image.src,
    alt: image.alt,
    className: css.image
  }), !!(tags && tags.length) && /*#__PURE__*/React.createElement("div", {
    className: css.tags
  }, tags)), /*#__PURE__*/React.createElement("div", {
    className: css.cardContent
  }, title && /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, title, icon && /*#__PURE__*/React.createElement("div", {
    onClick: onIconClick,
    className: css.iconContainer,
    onKeyPress: onIconClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    size: iconSize,
    color: iconColor
  }))), subtitle && /*#__PURE__*/React.createElement("div", {
    className: css.subtitle
  }, subtitle), installment && installment(), body && /*#__PURE__*/React.createElement("div", {
    className: css.body
  }, body)));
};
NewCardCarouselSmall.defaultProps = {
  iconSize: 20
};
export default NewCardCarouselSmall;